{
  "common.close": "닫기",
  "common.athleteFallback": "선수 {id}",
  "splash.title": "{app} — 활동 애니메이션 시각화",
  "splash.tagline": "Strava&nbsp;데이터를 움직이는 지도로",
  "splash.demo": "데모",
  "tab.query.title": "{name}님의 지도",
  "tab.query.heading": "활동 검색:",
  "tab.query.optDays": "최근 일수",
  "tab.query.optActivities": "최근 활동 수",
  "tab.query.optIds": "활동 ID",
  "tab.query.optDates": "기간",
  "tab.query.idsPlaceholder": "활동 ID를 입력하세요",
  "tab.query.after": "시작:",
  "tab.query.before": "종료:",
  "tab.query.autozoom": "가져온 후 검색 결과로 자동 확대 <i class=\"hf hf-bullseye\"></i>",
  "tab.query.queryButton": "<i class=\"hf hf-cloud-download\"></i> 검색",
  "tab.query.createAccount": "계정을 만들거나 로그인하세요.",
  "tab.query.sports": "종목:",
  "tab.query.allSports": "모든 종목",
  "tab.query.sportsExcept": "다음 제외 전체",
  "tab.query.sportsNone": "없음",
  "tab.query.loadingSports": "종목 불러오는 중…",
  "tab.query.sportsFailed": "이 지도의 종목을 불러오지 못했습니다",
  "tab.query.noSports": "아직 활동이 없습니다",
  "tab.activities.title": "표시된 활동",
  "tab.activities.clearSelection": "선택 해제",
  "tab.activities.renderSelected": "선택 항목 표시",
  "tab.activities.zoomToSelection": "<i class=\"fas fa-search-plus\"></i> <i class=\"far fa-object-group\"></i> <i class=\"fas fa-search-minus\"></i> 선택 영역으로 확대/축소",
  "tab.controls.title": "레이어 설정",
  "tab.controls.timescale": "시간 배율 <i>&tau;</i>",
  "tab.controls.timescaleHint": "재생 속도",
  "tab.controls.period": "주기 <i>T</i>",
  "tab.controls.periodHint": "실제 시간 ~ 모델 시간",
  "tab.controls.dotSize": "점 크기",
  "tab.controls.pathWidth": "경로 두께",
  "tab.controls.pathWidthHint": "0이면 경로가 숨겨집니다",
  "tab.controls.colors": "색상",
  "tab.controls.colorsHint": "팔레트 회전",
  "tab.controls.shadows": "그림자",
  "tab.profile.loginTitle": "로그인",
  "tab.profile.anonNote": "Strava로 로그인하면 내 활동을 보고 Heatflask 계정을 관리할 수 있습니다.",
  "tab.profile.loginLink": "Strava로 로그인",
  "tab.profile.editOnStrava": "Strava에서 프로필 편집",
  "tab.profile.indexNote": "빠르게 불러올 수 있도록 활동 요약을 색인해 둡니다.",
  "tab.profile.viewIndex": "색인 보기",
  "tab.profile.sharedMaps": "지도 공유",
  "tab.profile.sharedMapsNote": "끄기: Heatflask에서 내 활동은 나만 볼 수 있습니다. 켜기: 내 지도 링크가 있는 누구나 Strava에서 공개로 설정한 활동을 볼 수 있습니다. 비공개 활동은 어느 경우에도 나만 볼 수 있습니다. <a id=\"profile-privacy-link\" href=\"#\" target=\"_blank\" rel=\"noopener\">개인정보 보호 방식</a>",
  "tab.profile.logout": "로그아웃",
  "tab.profile.deleteAccount": "계정 삭제",
  "tab.profile.deleteConfirm": "Heatflask 계정을 삭제하시겠습니까?\n\n색인된 활동이 삭제되고, Heatflask의 Strava 데이터 접근 권한이 해제됩니다. 이 작업은 되돌릴 수 없습니다.",
  "tab.profile.languageHeading": "언어",
  "tab.profile.languageAuto": "자동",
  "tab.profile.translateNote": "<a id=\"translate-link\" target=\"_blank\" rel=\"noopener\">번역을 고치거나 새 언어를 추가하는 데 도움을 주세요!</a>",
  "tab.profile.unitsHeading": "단위",
  "tab.profile.unitsAuto": "자동",
  "tab.profile.unitsMetric": "미터법 (km, m)",
  "tab.profile.unitsImperial": "야드파운드법 (mi, ft)",
  "tab.profile.textSizeHeading": "글자 크기",
  "tab.profile.textSmaller": "작게",
  "tab.profile.textReset": "보통",
  "tab.profile.textLarger": "크게",
  "tab.profile.mapDefaultsHeading": "지도 기본값",
  "tab.profile.mapDefaultsNote": "링크에 자체 설정이 없는 지도를 열 때 이 배경 지도, 지형, 레이어 설정으로 시작합니다. 공유하는 링크에는 지금 보이는 화면이 그대로 표시됩니다.",
  "tab.profile.mapDefaultsSave": "기본값으로 저장",
  "tab.profile.mapDefaultsForget": "지우기",
  "tab.info.title": "정보",
  "tab.info.controlsHeading": "조작 방법",
  "tab.info.shiftDragKey": "<kbd>Shift</kbd> + 드래그",
  "tab.info.shiftDragDesc": "상자 안의 활동을 선택합니다. 터치스크린에서는 먼저 <i class=\"hf-object-group\"></i>을 탭한 다음 한 손가락으로 드래그하세요. 마지막으로 선택한 활동의 세부 정보가 표시되고, 활동 목록이 그 위치로 스크롤됩니다.",
  "tab.info.ctrlDragKey": "<kbd>Ctrl</kbd> + 드래그",
  "tab.info.ctrlDragDesc": "지도를 3D로 회전하고 기울입니다. 두 손가락으로도 할 수 있습니다",
  "tab.info.spaceKey": "<kbd>Space</kbd>",
  "tab.info.spaceDesc": "사이드바 열기/닫기",
  "tab.info.arrowsKey": "<kbd>&uarr;</kbd> <kbd>&darr;</kbd>",
  "tab.info.arrowsDesc": "이전/다음 사이드바 탭",
  "tab.info.escKey": "<kbd>Esc</kbd>",
  "tab.info.escDesc": "사이드바 닫기",
  "tab.info.liveUrlHeading": "실시간 URL",
  "tab.info.liveUrlDesc": "지도 보기와 애니메이션 설정이 페이지 URL에 저장되므로, 링크를 공유받은 사람도 같은 화면을 봅니다.",
  "tab.info.videoHeading": "동영상 내보내기",
  "tab.info.videoDesc": "<i class=\"hf-video-camera\"></i> 버튼은 애니메이션을 MP4로 녹화합니다. 버튼을 탭하고, 녹화할 지도 영역에 맞게 상자 크기를 조절한 뒤, 다시 탭하면 녹화가 시작됩니다. 애니메이션 한 주기 전체가 녹화되므로 동영상이 끊김 없이 반복됩니다. 주기가 {max}초(Strava가 받는 최대 동영상 길이)보다 길면 {max}초에서 잘립니다.",
  "tab.info.contributeHeading": "기여하기",
  "tab.info.sponsor": "<i class=\"hf-github\"></i> GitHub에서 후원하기",
  "tab.info.contactsHeading": "연락처",
  "map.basemapAndTerrain": "배경 지도와 지형",
  "map.pauseAnimation": "애니메이션 일시정지",
  "map.resumeAnimation": "애니메이션 재개",
  "capture.record": "동영상 녹화 ({period}초 반복)",
  "capture.recordTruncated": "동영상 녹화 (한 주기가 {period}초이며, 처음 {max}초만 녹화됩니다)",
  "capture.recordArea": "상자 안의 영역 녹화",
  "capture.stop": "녹화 중지",
  "capture.selectionTooSmall": "선택 영역이 너무 작습니다",
  "capture.saved": "{name} 저장됨 ({size})",
  "capture.cancelled": "녹화가 취소되었습니다",
  "capture.failed": "녹화 실패: {error}",
  "capture.loadingEncoder": "인코더 불러오는 중…",
  "capture.waitingForMap": "지도를 불러오는 중…",
  "capture.encoding": "인코딩 중… {percent}%",
  "capture.finalizing": "마무리하는 중…",
  "share.title": "이 지도의 링크 공유",
  "share.copied": "링크가 복사되었습니다",
  "share.copiedUnshared": "링크가 복사되었지만, 지도가 공유되지 않은 상태라 다른 사람은 열 수 없습니다. 지도 공유를 켜면 열 수 있습니다.",
  "share.unshared": "지도가 공유되지 않은 상태라 다른 사람은 이 링크를 열 수 없습니다. 지도 공유를 켜면 열 수 있습니다.",
  "share.copyThis": "이 링크를 복사하세요:",
  "update.available": "Heatflask의 새 버전이 있습니다.",
  "update.reload": "새로고침",
  "import.title": "가져오는 중",
  "import.stop": "중지",
  "import.stopping": "중지하는 중…",
  "import.contacting": "Strava에 연결하는 중…",
  "import.countOf": "활동 {received} / {total}개",
  "import.count": "활동 {received}개",
  "import.waitStrava": "Strava의 다운로드 한도 때문에 {time}까지 일시정지되었습니다. 이 창을 열어 두세요. 새로고침해도 빨라지지 않습니다.",
  "import.waitRationed": "오늘의 빠른 다운로드를 모두 사용했습니다. 나머지는 {time}부터 더 천천히 이어집니다. 이 창을 열어 두세요.",
  "import.dailyLimit": "Strava의 일일 다운로드 한도를 모두 사용했습니다. {time} 이후에 다시 시도하세요.",
  "import.dailyRationed": "오늘 사용할 수 있는 Strava 다운로드를 모두 사용했습니다. {time} 이후에 다시 시도하세요.",
  "import.noActivitiesYet": "Strava 계정에 아직 활동이 없습니다. Strava에서 활동을 기록하거나 업로드하면 여기에 표시됩니다.",
  "table.noActivities": "활동 없음",
  "table.untitled": "(제목 없음)",
  "activities.pageTitle": "{app} — 활동 색인",
  "activities.heading": "활동 색인",
  "activities.fetching": "활동을 가져오는 중...",
  "activities.rateLimit": "Strava 요청 한도에 도달했습니다. {time}에 재개합니다",
  "activities.noData": "데이터가 없습니다 &#128577;",
  "activities.colServerCache": "서버(Mongo)에 저장된 경로",
  "activities.colBrowserCache": "이 브라우저에 저장된 경로",
  "activities.cachedServer": "{id}의 경로가 서버에 저장되어 있습니다",
  "activities.notCachedServer": "{id}의 경로가 서버에 저장되어 있지 않습니다",
  "activities.cachedBrowser": "{id}의 경로가 이 브라우저에 저장되어 있습니다",
  "activities.notCachedBrowser": "{id}의 경로가 이 브라우저에 저장되어 있지 않습니다",
  "sport.AlpineSki": "알파인 스키",
  "sport.BackcountrySki": "백컨트리 스키",
  "sport.Badminton": "배드민턴",
  "sport.Basketball": "농구",
  "sport.Canoeing": "카누",
  "sport.Cricket": "크리켓",
  "sport.Crossfit": "크로스핏",
  "sport.Dance": "댄스",
  "sport.EBikeRide": "전기자전거 라이딩",
  "sport.Elliptical": "일립티컬",
  "sport.EMountainBikeRide": "전기 산악자전거 라이딩",
  "sport.Golf": "골프",
  "sport.GravelRide": "그래블 라이딩",
  "sport.Handcycle": "핸드사이클",
  "sport.HighIntensityIntervalTraining": "HIIT",
  "sport.Hike": "하이킹",
  "sport.IceSkate": "아이스 스케이트",
  "sport.InlineSkate": "인라인 스케이트",
  "sport.Kayaking": "카약",
  "sport.Kitesurf": "카이트서핑",
  "sport.MountainBikeRide": "산악자전거 라이딩",
  "sport.NordicSki": "크로스컨트리 스키",
  "sport.Padel": "파델",
  "sport.PhysicalTherapy": "물리치료",
  "sport.Pickleball": "피클볼",
  "sport.Pilates": "필라테스",
  "sport.Racquetball": "라켓볼",
  "sport.Ride": "라이딩",
  "sport.RockClimbing": "암벽 등반",
  "sport.RollerSki": "롤러스키",
  "sport.Rowing": "조정",
  "sport.Run": "달리기",
  "sport.Sail": "요트",
  "sport.Skateboard": "스케이트보드",
  "sport.Snowboard": "스노보드",
  "sport.Snowshoe": "스노슈잉",
  "sport.Soccer": "축구",
  "sport.Squash": "스쿼시",
  "sport.StairStepper": "스테퍼",
  "sport.StandUpPaddling": "스탠드업 패들링",
  "sport.Surfing": "서핑",
  "sport.Swim": "수영",
  "sport.TableTennis": "탁구",
  "sport.Tennis": "테니스",
  "sport.TrailRun": "트레일 러닝",
  "sport.Velomobile": "벨로모빌",
  "sport.VirtualRide": "가상 라이딩",
  "sport.VirtualRow": "가상 조정",
  "sport.VirtualRun": "가상 달리기",
  "sport.Volleyball": "배구",
  "sport.Walk": "걷기",
  "sport.WeightTraining": "웨이트 트레이닝",
  "sport.Wheelchair": "휠체어",
  "sport.Windsurf": "윈드서핑",
  "sport.Workout": "운동",
  "sport.Yoga": "요가"
}
